import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const DealPromptNoResultsView = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      data-test="deal-prompt--no-results-view"
      sx={{
        backgroundColor: 'background.grayLight',
        flexGrow: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 8,
      }}
    >
      <Typography sx={{ fontWeight: 'fontWeightBold', fontSize: '18px' }}>
        {t('No matching inventory found')}
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {t('Your query returned no result, likely due to a very specific combination of targeting parameters.')}
      </Typography>
    </Box>
  );
};
